"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagTW = function FlagTW(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H4.74a7.06,7.06,0,0,1,7.06,7.06V5.12a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,5.12V-114.94a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.88-54.91a25.21,25.21,0,0,1,7.4-17.87l-21.18-6.06a1.23,1.23,0,0,0-1.19,2.07L-115-61.45l-21.39,5.35a1.23,1.23,0,0,0,0,2.38L-115-48.37-130.85-33A1.23,1.23,0,0,0-129.66-31L-108.48-37a25.2,25.2,0,0,1-7.4-17.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-108.47-72.79a25.2,25.2,0,0,1,17.87-7.4,25.21,25.21,0,0,1,17.87,7.4L-66.67-94a1.23,1.23,0,0,0-2.07-1.19L-84.06-79.31l-5.35-21.39a1.23,1.23,0,0,0-2.38,0l-5.35,21.39-15.33-15.85A1.23,1.23,0,0,0-114.53-94Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.73-37a25.21,25.21,0,0,1-17.87,7.4A25.2,25.2,0,0,1-108.47-37l-6.06,21.18a1.23,1.23,0,0,0,2.07,1.19l15.32-15.85,5.35,21.39a1.23,1.23,0,0,0,2.38,0l5.35-21.39,15.32,15.85a1.23,1.23,0,0,0,2.07-1.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-44.81-56.1-66.2-61.45l15.85-15.32a1.23,1.23,0,0,0-1.19-2.07l-21.18,6.06a25.21,25.21,0,0,1,7.4,17.87A25.21,25.21,0,0,1-72.72-37L-51.54-31A1.22,1.22,0,0,0-50.35-33L-66.2-48.37l21.39-5.35a1.23,1.23,0,0,0,0-2.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-70.47-54.91A20.13,20.13,0,0,1-90.6-34.78a20.13,20.13,0,0,1-20.13-20.13A20.13,20.13,0,0,1-90.6-75,20.13,20.13,0,0,1-70.47-54.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagTW;
exports["default"] = _default;